import { useQuery } from "@tanstack/react-query";
import { getComoConfig } from "../../api/bComoApi";

export const useGetComoConfig = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["como-config", organisationId],
    queryFn: () => getComoConfig(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
